import React, { useEffect, useState } from 'react';
import { useContact, useConnected } from '../../hooks';
import './CustomLayout.css';

export default function () {
  const [contactId, setContactId] = useState<string>('');
  const [caseId, setCaseId] = useState<string>('');
  const [copiedContactId, setCopiedContactId] = useState(false);
  const [copiedCaseId, setCopiedCaseId] = useState(false);
  const [contactTimer, setContactTimer] = useState<NodeJS.Timeout | null>(null);
  const [caseTimer, setCaseTimer] = useState<NodeJS.Timeout | null>(null);

  useContact((contact: any) => {
    const id = contact.getContactId();
    setContactId(id || '');
    
    const attributes = contact.getAttributes();
    const caseid = attributes.caseid?.value;
    setCaseId(caseid || '');
  });

  useConnected((contact: any) => {
    const id = contact.getContactId();
    setContactId(id || '');
    
    const attributes = contact.getAttributes();
    const caseid = attributes.caseid?.value;
    setCaseId(caseid || '');
  });

  useEffect(() => {
    const customHeight = document.querySelector('.custom-wrapper')?.clientHeight ?? 0;
    const windowHeight = window.innerHeight;
    const iframe = document.querySelector('.ccp-container')?.querySelector('iframe');
    if (iframe) {
      iframe.style.height = (windowHeight - customHeight) + 'px';
    }
  }, [contactId, caseId]);

  const copyToClipboard = (text: string, type: 'contact' | 'case') => {
    navigator.clipboard.writeText(text);
    if (type === 'contact') {
      if (contactTimer) clearTimeout(contactTimer);
      setCopiedContactId(true);
      const timer = setTimeout(() => setCopiedContactId(false), 2000);
      setContactTimer(timer);
    } else {
      if (caseTimer) clearTimeout(caseTimer);
      setCopiedCaseId(true);
      const timer = setTimeout(() => setCopiedCaseId(false), 2000);
      setCaseTimer(timer);
    }
  };

  return (
    <div className="custom-wrapper">
      {(contactId || caseId) && (
        <div className="info-panel">
          {contactId && (
            <div className="info-item">
              <label>Contact ID:</label>
              <span className="info-value">{contactId}</span>
              <button 
                className="copy-btn" 
                onClick={() => copyToClipboard(contactId, 'contact')}
              >
                {copiedContactId ? 'Copied' : 'Copy'}
              </button>
            </div>
          )}
          {caseId && (
            <div className="info-item">
              <label>Case ID:</label>
              <span className="info-value">{caseId}</span>
              <button 
                className="copy-btn" 
                onClick={() => copyToClipboard(caseId, 'case')}
              >
                {copiedCaseId ? 'Copied' : 'Copy'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
